export const SET_ACCOUNT_OPPORTUNITIES = 'SET_ACCOUNT_OPPORTUNITIES';



// WEBPACK FOOTER //
// ./src/components/page/SimpleTable/flow/actionTypes.js